<template>
  <div class="custom-page-box">
    <a-card :bordered="false" title="全部服务" :headStyle="{fontSize:'18px'}">
      <a-form>
        <search-header :col="3">
          <search-list>
            <a-form-item label="服务分类" v-bind="searchItemLayout">
              <a-select
                style="width: 100%"
                v-model="queryParams.serviceCategoryId"
                placeholder="请选择" allowClear
              >
                <a-select-option v-for="(item,index) in serviceCategoryList" :key="index" :value="item.id">{{
                    item.name
                  }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="应用名称" v-bind="searchItemLayout">
              <a-input v-model="queryParams.serverName" placeholder="请输入"></a-input>
            </a-form-item>
            <a-form-item style="margin-left:20px;">
              <a-button type="primary" @click="searchBtn">查询</a-button>
            </a-form-item>
          </search-list>
        </search-header>
      </a-form>
      <div :style="{ marginBottom: '8px' }">
        <a-radio-button :value="0" :checked="type===0" @click="onTypeChange(0)">
          <sort-button name="默认排序" :show-icon="false"></sort-button>
        </a-radio-button>
        <a-radio-button :value="1" :checked="type===1" @click="onTypeChange(1)">
          <sort-button name="使用数量" :type="type===1?(sort===0?'up':'down'):''"></sort-button>
        </a-radio-button>
        <a-radio-button :value="2" :checked="type===2" @click="onTypeChange(2)">
          <sort-button name="发布时间" :type="type===2?(sort===0?'up':'down'):''"></sort-button>
        </a-radio-button>
      </div>
      <service-list-component
        ref="pageList"
        :firstCall="false"
        :load-promise="getServerListPromise"
        @onItemClick="onItemClickEvent"
      >
      </service-list-component>
    </a-card>
  </div>
</template>

<script>
import ServiceListComponent from './components/ServiceListComponent'
import { SortButton } from '@/customComponents'
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'ServiceList',
  components: { ServiceListComponent, SortButton },
  mixins: [searchForm],
  data() {
    return {
      sort: 0,
      type: 0,
      queryParams: {},
      serviceCategoryList: []
    }
  },
  mounted() {
    this.getServiceCategoryList()
    this.getDetail()
  },
  methods: {
    searchBtn() {
      this.$refs.pageList.refresh()
    },
    getDetail() {
      let params = {
        merchantId: this.$store.getters.userInfo.merchantId
      }
      this.getHttpServices().getUserService().get('api/v2/merchant/detail', params)
        .then(res => {
          this.queryParams.merchantType = res.merchantType
          this.queryParams.saleProductList = res.saleProductList
          this.$refs.pageList.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getServiceCategoryList() {
      this.getHttpServices().getServerApiService().post('serviceCategory/getList?pageNum=1&pageSize=1000', {})
        .then(res => {
          this.serviceCategoryList = res.data.filter(item => item.status == 1)
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    getServerListPromise(params) {
      let queryParams = {
        limitDto: {
          ...params
        },
        sort: this.sort,
        type: this.type,
        ...this.queryParams
      }
      return this.getHttpServices().getServerApiService().post('service/selectAllServerList', queryParams)
    },
    onTypeChange(value) {
      this.getLogUtils().logWithTag('onTypeChange', value)

      if (value === 0) {
        this.sort = 0
      } else if (value === 1 || value === 2) {
        this.sort = this.type === value && this.sort === 1 ? 0 : 1
      }
      this.type = value
      this.$refs.pageList.refresh()
    },
    onItemClickEvent(item) {
      this.openNewPage('ServiceDetail', {
        serverId: item.serverId
      })
    }
  }
}
</script>
<style lang="less">
</style>